import { getOrderHisPanel } from "../../services/OrderHisServices";
import { getOrderHisDetailPanel } from "../../services/OrderHisDetailServices";
import { PedidosHistorialContext } from "./PedidosHistorialContext"

export const PedidosHistorialState = ({ children }) => {

    const getPedidosHistorialPanelData = async (searchCli, searchSel, dateFrom, dateUntil, numpag, filas) => {
        let res = await getOrderHisPanel(searchCli, searchSel, dateFrom, dateUntil, numpag, filas);
        await Promise.all(res.pedidos.map(async (pedido) => {
            const data = await getOrderHisDetailPanel(pedido.ord_id, null, 1, 250);
            const totalpedido = data.orderHisDetails.reduce(
              (sum, item) => sum + (item.ode_total_amount || 0),
              0
            );
            pedido.totalpedido = totalpedido;
          }));
        return res;
    };

    return <PedidosHistorialContext.Provider value={{
        getPedidosHistorialPanelData,
    }} >
        {children}
    </PedidosHistorialContext.Provider>
}